import router from './router'

export default {
	moduleName: 'banner',
	router
}



// WEBPACK FOOTER //
// ./src/core/modules/banner/index.js